import { useEffect, useState } from 'react';
import { useAuth } from '../lib/auth';
import { picturesApi, setPicture, type PhonePicture, type PictureSize } from '../lib/pictures';
import { PhotoEditor } from './PhotoEditor';

/**
 * Your own photo (Your settings, and the invitation's last step): shown wherever Stitch shows you,
 * and on desk phones when you call coworkers (for each company where you have an extension).
 */
export function YourPhoto({ autoFocus }: { autoFocus?: boolean }) {
  const { state } = useAuth();
  const user = state?.user;
  const [phones, setPhones] = useState<PhonePicture[]>();
  const withPhone = (state?.memberships ?? []).filter((m) => m.tenant && m.extension);
  const uid = user?.id;
  useEffect(() => {
    if (!uid) return;
    let alive = true;
    picturesApi.mine().then(
      (r) => {
        if (!alive) return;
        shown(uid, r.version);
        setPhones(r.phones);
      },
      () => undefined
    );
    return () => {
      alive = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uid]);
  if (!user) return null;
  /** Shown at once on this device: here, the menu, and wherever this person's face is. */
  function shown(id: string, version: string | null) {
    setPicture(id, version);
    for (const m of withPhone) setPicture(id, version, { tenant: m.tenant, extension: m.extension ?? null });
  }
  return (
    <PhotoEditor
      userId={user.id}
      name={user.name || user.email}
      whose="your"
      {...(autoFocus ? { autoFocus } : {})}
      {...(phones ? { phones } : {})}
      save={async (files: Record<PictureSize, string>) => {
        const r = await picturesApi.saveMine(files);
        shown(user.id, r.version);
        setPhones(r.phones);
      }}
      remove={async () => {
        const r = await picturesApi.removeMine();
        shown(user.id, null);
        setPhones(r.phones);
      }}
      onRetry={async () => setPhones((await picturesApi.retryMine()).phones)}
    />
  );
}
